import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Header } from 'semantic-ui-react';
import styled from 'styled-components';

import { Planning } from 'actions';
import { colors } from 'utils/colors';

class EducationCard extends Component {
  state = {
    expanded: false,
  };

  componentDidMount() {
    const { dispatch, savingGoals } = this.props;

    if (Object.keys(savingGoals).length === 0) {
      dispatch(Planning.getSavingGoals());
    }
  }

  toggleExpand = () => {
    this.setState((prev) => ({ expanded: !prev.expanded }));
  };

  render() {
    const { expanded } = this.state;
    const { savingGoals } = this.props;
    let { tuition, accommodation } = savingGoals.undergraduate || {};
    tuition = Math.round(tuition || 29190);
    accommodation = Math.round(accommodation || 51484);
    const total = tuition + accommodation;

    return (
      <CardWrapper expanded={expanded}>
        <div style={{ minWidth: '341px', padding: '20px' }}>
          <IconHeader>
            <Icon
              name="graduation cap"
              color="orange"
              size="large"
              style={{ margin: 0 }}
            />
          </IconHeader>

          <CardTitle>Saving for Your Child&apos;s Education (RESP)</CardTitle>
          <CardSubtitle>Start planning now. They grow up fast.</CardSubtitle>

          <ShowToggle onClick={this.toggleExpand}>
            {expanded ? (
              <React.Fragment>
                Show Less <Icon name="angle up" />
              </React.Fragment>
            ) : (
              <React.Fragment>
                Learn More <Icon name="angle down" />
              </React.Fragment>
            )}
          </ShowToggle>
        </div>
        <CollapsibleSection expanded={expanded}>
          <div>
            <Divider />
            <SectionTitle style={{ textAlign: 'center' }}>
              Average Education Cost in Canada (2025)
            </SectionTitle>
            <SubText style={{ textAlign: 'center' }}>
              Post-Secondary / 4-Year Total
            </SubText>

            <Row>
              <span>Tuition:</span>
              <Value>${tuition.toLocaleString()}</Value>
            </Row>
            <Row>
              <span>Room &amp; Board:</span>
              <Value>${accommodation.toLocaleString()}</Value>
            </Row>

            <TotalRow>
              <span>Total:</span>
              <TotalValue>${total.toLocaleString()}</TotalValue>
            </TotalRow>

            <Divider />

            <SectionLabel>RESP Maximum Lifetime Contribution:</SectionLabel>
            <SubText>$50,000 per eligible beneficiary</SubText>

            <SectionLabel>Canada Education Savings Grant (CESG):</SectionLabel>
            <SubText>
              The grant amount is 20% of your annual contributions up to $500
              per year and a lifetime maximum of $7,200 per beneficiary. For
              more information, visit{' '}
              <a
                href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/registered-education-savings-plans-resps/canada-education-savings-programs-cesp/canada-education-savings-grant-cesg.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .
            </SubText>
            <SectionLabel style={{ whiteSpace: 'nowrap' }}>
              Quebec Education Savings Incentive (QESI):
            </SectionLabel>
            <SubText>
              Quebec residents can receive a refundable provincial tax credit of
              10% on annual RESP contributions, up to $250 per year per
              beneficiary, with a lifetime maximum of $3,600. The QESI is paid
              directly into your RESP.
            </SubText>
          </div>
        </CollapsibleSection>
      </CardWrapper>
    );
  }
}

EducationCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  savingGoals: PropTypes.object,
};

EducationCard.defaultProps = {
  savingGoals: {},
};

export default connect((state) => ({
  savingGoals: state.Planning.savingGoals,
}))(EducationCard);

const CardWrapper = styled.div`
  background: white;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  width: 100%;
  max-width: 473px;
  margin: 0.5rem;
  overflow: hidden;
  max-height: ${(props) => (props.expanded ? '665px' : '214px')};
  transition: max-height 0.4s ease-in-out;
`;

const IconHeader = styled.div`
  background: #ffe7d6;
  border-radius: 50%;
  display: inline-block;
  padding: 0.75rem;
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
`;

const CardSubtitle = styled.p`
  color: #555;
  margin-bottom: 1rem;
`;

const ShowToggle = styled.button`
  background: none;
  border: none;
  color: ${colors.blue};
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;

  &:hover {
    text-decoration: underline;
  }
  i {
    text-decoration: none !important;
  }
`;

const CollapsibleSection = styled.div`
  overflow: hidden;
  text-align: left;
  max-height: ${(props) => (props.expanded ? '700px' : '0')};
  padding: ${(props) => (props.expanded ? '0 20px 20px' : '0 20px')};
  opacity: ${(props) => (props.expanded ? 1 : 0)};
  pointer-events: ${(props) => (props.expanded ? 'auto' : 'none')};
  transition: max-height 0.4s ease, opacity 0.4s ease, padding 0.4s ease-in-out;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #ddd;
`;

const SectionTitle = styled(Header)`
  &&& {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
`;

const SectionLabel = styled.p`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.25rem;
`;

const SubText = styled.p`
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.25rem auto;
  width: 80%;
  max-width: 350px;
  font-weight: 600;
  font-size: 1rem;

  span:first-child {
    color: black;
  }
`;

const Value = styled.span`
  color: ${colors.blue};
`;

const TotalRow = styled(Row)`
  margin-top: 0.75rem;
  border-top: 1px solid #ddd;
  padding-top: 0.75rem;
  font-weight: bold;
  font-size: 1.1rem;
`;

const TotalValue = styled(Value)`
  font-size: 1.1rem;
  font-weight: bold;
`;
